import { css } from '@emotion/core'
import { colors, H6, Subheading } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Header({ isSurvivingPerson }) {
  const { t } = useTranslation()
  const headerBackground = css`
    background-color: ${isSurvivingPerson ? colors.transparent.green02 : colors.transparent.danger02};
    padding: 0px 16px;
  `
  const heading = isSurvivingPerson
    ? t('person.merges.survivingPerson', 'Surviving Person')
    : t('possibleDuplicate', 'Possible Duplicate')
  const subHeading = isSurvivingPerson
    ? t(
        'tools.adminMerge.headings.survivingPersonSubHeading',
        'Information in this column will be saved at the end of the merge.'
      )
    : t(
        'tools.adminMerge.headings.possibleDuplicateSubheading',
        'Information in this column will be deleted at the end of the merge.'
      )

  return (
    <div css={headerBackground}>
      <H6>
        {heading}
        <Subheading>{subHeading}</Subheading>
      </H6>
    </div>
  )
}
